import AbstractConfig from './AbstractConfig';
import GalleryBannerConfig from './GalleryBannerConfig';

export default class GallerySectionConfig extends AbstractConfig {
  public name(): string {
    return this.get('name');
  }

  public stack(): boolean {
    return this.get('stack');
  }

  public banners(): GalleryBannerConfig[] {
    return this.get('banners').map(source => new GalleryBannerConfig(source));
  }
}
